import {USER_TYPE} from 'containers/ManageUserPage/userType';

const WISBIT_INDEX = '/wisbit';

export enum MODE {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export const ROUTE_PARAMS = {
  id: ':id',
  type: ':type',
  mode: ':mode',
};

export const ROUTE = {
  Index: '/',
  Dashboard: '/dashboard',
  Wisbit: {
    Index: WISBIT_INDEX,
    Template: `${WISBIT_INDEX}/template`,
    Create: `${WISBIT_INDEX}/new`,
    Edit: `${WISBIT_INDEX}/${ROUTE_PARAMS.id}/${ROUTE_PARAMS.mode}`,
  },
  ContentCreator: `/${USER_TYPE.CONTENT_CREATOR.id}`,
  Learner: `/${USER_TYPE.LEARNER.id}`,
  Manager: `/${USER_TYPE.ADMIN.id}`,
  Organization: `/organization`,
  Tags: '/tags',
  ResetPassword: '/reset-password',
  ResetPasswordConfirm: '/reset-password/confirm',
};
